import React, { useState } from "react";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Axios from "../../utils/Axios";
import SummaryAPI from "../../common/SummaryAPI";
import AxiosToastError from "../../utils/AxiosToastError";
import Cards from "../../components/card/Card";
import background from "../../assets/wall.jpg";

const Recommend = () => {
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);

  const handleRecommendations = async () => {
    if (!user || !user._id) {
      toast.error("Please log in to get recommendations.");
      return;
    }

    setLoading(true);

    try {
      const response = await Axios({
        ...SummaryAPI.getRecommendations,
        data: { userID: user._id },
      });

      if (response.data.error) {
        toast.error(response.data.message);
        return;
      }

      if (response.data.success) {
        toast.success(response.data.message);
      }

      const movieIDs = response.data.data;
      const movies = [];
      const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
      for (let i = 0; i < movieIDs.length; i++) {
        const res = await fetch(
          `https://api.themoviedb.org/3/movie/${movieIDs[i]}?api_key=${API_KEY}`
        );
        const data = await res.json();
        movies.push(data);
      }

      setRecommendations(movies);
    } catch (error) {
      AxiosToastError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wall" style={{ backgroundImage: `url(${background})` }}>
      <div className="movieList">
        <div>
          <button
            onClick={handleRecommendations}
            className="recommendButton"
          >
            Recommend Movies
          </button>
        </div>

        {loading && (
          <div>
            Fetching your recommendations...
          </div>
        )}

        {!loading && recommendations.length > 0 && (
          <div className="Movies">
            {recommendations.map((movie) => (
              <Cards movie={movie} />
            ))}
          </div>
        )}

        {!loading && recommendations.length === 0 && (
          <div>
            No recommendations yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default Recommend;
